import React, { Component } from 'react';
import { connect } from 'react-redux';

const mapStateToProps = ({ system: { environment }}) =>
  ({ environment });

export function ErrorPanel({ error }) {
  return (
    <div style={{ backgroundColor: 'red', color: 'white' }}>
      {error.toString()}
    </div>
  );
}

export function ProductionError({ error }) {
  return (
    <span data-error={error.toString()} />
  );
}

class ErrorBoundary extends Component {
    static defaultProps = {
      environment: 'production'
    }

    state = { error: null, info: null };

    componentDidCatch(error) {
      this.setState({ error });
      // TODO log error?
    }

    render() {
      const { environment, children } = this.props;
      const { error } = this.state;
      if (error !== null) {
        return environment === 'production' ?
          <ProductionError error={error} /> :
          <ErrorPanel error={error} />;
      }
      return children;
    }
}

export default connect(mapStateToProps)(ErrorBoundary);
